import React from "react";

const ChillerVanFleetTable = ({ title, description, image, imageAlt, columns, rows, note }) => {
  return (
    <section className="container-fluid py-5 overflow-hidden" style={{ background: "#fff" }}>
      <div className="container py-3">
        <div className="row align-items-center">
          <div
            className="col-md-4 mb-4 mb-md-0"
            data-aos="fade-right"
            data-aos-duration="1200"
            data-aos-once="true"
          >
            <div className="about-image-wrapper">
              <img
                src={image}
                alt={imageAlt}
                className="about-image"
                loading="lazy"
              />
            </div>
          </div>

          <div
            className="col-md-8 d-flex flex-column justify-content-start"
            data-aos="fade-left"
            data-aos-duration="1200"
            data-aos-once="true"
          >
            <h2 className="h2-title mb-3">{title}</h2>
            <p style={{ fontSize: "1.6rem", color: "#555", lineHeight: 1.7, marginBottom: "24px" }}>
              {description}
            </p>

            <div className="table-responsive">
              <table className="cv-fleet-spec-table">
                <thead>
                  <tr>
                    {columns.map((col, i) => (
                      <th key={i}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, i) => (
                    <tr key={i}>
                      <td><strong>{row.model}</strong></td>
                      <td>{row.payload}</td>
                      <td>{row.roof}</td>
                      <td>{row.use}</td>
                      <td>{row.temp}</td>
                      <td>{row.duration}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {note && <p className="cv-fleet-spec-note">{note}</p>}

            <div className="d-flex flex-wrap gap-3 mt-4">
              <a href="tel:+971544792905" className="mini-btn primary">Call Now</a>
              <a
                href="https://wa.me/971544792905"
                target="_blank"
                rel="noopener noreferrer"
                className="mini-btn secondary-dark"
              >
                WhatsApp Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChillerVanFleetTable;
